export enum ReciboEstado {
  Borrador,
  Enviado,
  Recepcionado,
}

export const ReciboEstadoLabels: { [key in ReciboEstado]: string } = {
  [ReciboEstado.Borrador]: 'Borrador',
  [ReciboEstado.Enviado]: 'Enviado',
  [ReciboEstado.Recepcionado]: 'Recepcionado',
};

export const getReciboEstado = () => {
  return Object.values(ReciboEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ReciboEstadoLabels[id as ReciboEstado],
    }));
};

export const colorMapping: { [key in ReciboEstado]: string } = {
  [ReciboEstado.Borrador]: '#70BDFF',
  [ReciboEstado.Enviado]: 'orange',
  [ReciboEstado.Recepcionado]: '#22c55e',
};
